export default __webpack_public_path__ + "static/media/uploader-animas-problem-1.cc6823fc.png";